import React from 'react'
import { components, type OptionProps } from 'react-select'
import { CheckboxBase } from '@instacart/ids-core'
import { OptionContainer } from 'domains/aggregate-store-performance/utils/helpers/Dropdown.utils'
import { type StoreGroupDropdownOption } from 'domains/aggregate-store-performance/components/store-group-dropdown/utils/StoreGroupDropdown.types'

export const Option = (props: OptionProps<StoreGroupDropdownOption>) => {
  const checkboxId = `group-checkbox-${props.data.value}`
  const selectedValues = props.getValue() as StoreGroupDropdownOption[]
  const isSelected = selectedValues
    ? selectedValues.some((option: StoreGroupDropdownOption) => option.value === props.data.value)
    : false

  return (
    <components.Option {...props}>
      <OptionContainer>
        <CheckboxBase checked={isSelected} id={checkboxId} />
        {props.children}
      </OptionContainer>
    </components.Option>
  )
}
